module.exports = __webpack_public_path__ + "img/gcr-autocollant-vf.f568e443.jpg";